import type { Theme } from '@mui/material/styles'

const MuiLoadingButton = (baseTheme: Theme) => ({
  defaultProps: {
    color: 'inherit',
    variant: 'contained',
  },
  styleOverrides: {
    root: {
      ...baseTheme.typography.button,
    },
  },
})

export default MuiLoadingButton
